<template>
  <div class="container">
    <div>
      <!-- <div class="mwow-button-filled success" @click="addStudent">添加学员</div> -->
      <div class="mwow-button-filled primary" @click="clickexport">导出</div>
      <!-- 批量修改下拉按钮 -->
      <div
        v-if="multipleSelection.length > 0"
        style="display: inline-block; margin-left: 20px"
      >
        <el-popover
          placement="bottom"
          width="70"
          trigger="click"
          :visible-arrow="false"
          popper-class="no-padding"
          :disabled="multipleSelection.length === 0"
        >
          <slot>
            <div class="muti-buttons">
              <teacher-edit :ori="multipleSelection" @change="handleRefresh">
                <div class="btn">教务老师</div>
              </teacher-edit>
              <follow-staff-edit
                :ori="multipleSelection"
                @change="handleRefresh"
              >
                <div class="btn">课程顾问</div>
              </follow-staff-edit>
            </div>
          </slot>
          <div slot="reference" class="mwow-button-filled primary">
            批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
          </div>
        </el-popover>
      </div>
      <div v-else style="display: inline-block; margin-left: 20px">
        <div
          class="mwow-button-filled"
          style="
            background: #f5f7fa !important;
            border-color: #f5f7fa !important;
            color: #c2c3c4 !important;
          "
        >
          批量修改<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
        </div>
      </div>
    </div>
    <div class="searchBox">
      <el-form size="mini" ref="form" :model="searchInfo" inline>
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:">
              <el-input
                placeholder="学员姓名/手机号"
                v-model="searchInfo.key_word"
                @change="handleSearch"
                @clear="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别:">
              <el-select
                v-model.number="searchInfo.sex"
                clearable
                @change="handleSearch"
                placeholder="请选择"
                class="drawer_onlychoose"
              >
                <el-option
                  v-for="item in sexList"
                  :key="item.value"
                  :label="item.value"
                  :value="Number(item.key)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄分布:">
              <el-select
                v-model="searchInfo.age_stage"
                placeholder="请选择"
                clearable
                @change="handleSearch"
              >
                <el-option label="暂无年龄" :value="8"></el-option>
                <el-option label="X ≤ 3" :value="1"></el-option>
                <el-option label="3 < X ≤ 6" :value="2"></el-option>
                <el-option label="6 < X ≤ 9" :value="3"></el-option>
                <el-option label="9 < X ≤ 12" :value="4"></el-option>
                <el-option label="12 < X ≤ 15" :value="5"></el-option>
                <el-option label="15 < X ≤ 18" :value="6"></el-option>
                <el-option label="18 < X" :value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="年龄筛选:">
              <div class="inputBox">
                <el-input
                  v-model.number="searchInfo.age_start"
                  type="number"
                  placeholder="开始年龄"
                  @change="handleSearch"
                ></el-input>
                <span>至</span>
                <el-input
                  v-model.number="searchInfo.age_end"
                  type="number"
                  placeholder="结束年龄"
                  @change="handleSearch"
                >
                </el-input>
                <span
                  class="el-icon-error clear-icon"
                  v-if="searchInfo.age_start && searchInfo.age_end"
                  @click="
                    () => {
                      searchInfo.age_start = '';
                      searchInfo.age_end = '';
                      handleSearch();
                    }
                  "
                ></span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所在班级:">
              <el-select
                v-model.number="searchInfo.class_id"
                filterable
                clearable
                placeholder="请选择"
                @change="handleSearch"
                @clear="getSelectrList('class')"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'class');
                  }
                "
              >
                <el-option :key="0" label="未分配" :value="0"> </el-option>
                <el-option
                  v-for="item in className"
                  :key="item.class_id"
                  :label="item.name"
                  :value="Number(item.class_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级教师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.class_teacher_id"
                :defaultSelected.sync="searchInfo.class_teacher_list"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="showFormSearch">
          <el-col :span="8">
            <el-form-item label="教务老师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :defaultSelected.sync="searchInfo.teacher_list"
                :jobIds="[2]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问:">
              <common-staff-pull-down
                :originId.sync="searchInfo.follow_staff_id"
                :defaultSelected.sync="searchInfo.follow_staff_list"
                :jobIds="[3]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户意向:" prop="intent">
              <el-select
                v-model="searchInfo.degree_of_interest"
                multiple
                filterable
                default-first-option
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="D" key="0" :value="0"> </el-option>
                <el-option label="C" key="1" :value="1"> </el-option>
                <el-option label="B" key="2" :value="2"> </el-option>
                <el-option label="A" key="3" :value="3"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="showFormSearch">
          <el-col :span="8">
            <el-form-item label="首次入学时间:">
              <!-- <el-date-picker
                v-model="searchInfo.enter_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.enter_date"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
              <!-- <div class="inputBox">
                <el-input
                  v-model="searchInfo.date_start"
                  placeholder="开始时间"
                  @change="
                    (v) => {
                      handleSearch();
                    }
                  "
                ></el-input>
                <span>至</span>
                <el-input
                  v-model="searchInfo.date_end"
                  placeholder="结束时间"
                  @change="
                    (v) => {
                      handleSearch();
                    }
                  "
                >
                </el-input>
              </div> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最近入学时间:">
              <!-- <el-date-picker
                v-model="searchInfo.latest_transform_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.latest_transform_time"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                clearable
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="time-line-switch">
          <div class="p4" @click="showFormSearch = !showFormSearch">
            {{ showFormSearch ? "收起" : "展开" }}
            <span
              :class="
                showFormSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></span>
          </div>
        </div>
        <div class="time-line-switch resetting">
          <div class="p4" @click="resetSearch">
            重置
            <span class="el-icon-refresh-right"></span>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table
        v-horizontal-scroll
        size="mini"
        ref="multipleTable"
        tooltip-effect="dark"
        stripe
        style="width: 100%"
        :data="tableData"
        @selection-change="handleSelectionChange"
        @sort-change="clickStort"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          :selectable="(row) => row._mark !== 1"
        ></el-table-column>
        <el-table-column label="学员姓名" width="180" prop="name">
          <template slot-scope="scope">
            <div
              class="mwow-green studentName"
              @click="goStudentDetail(scope.row.student_id.toString())"
            >
              {{ scope.row.name || "-" }}
              <span
                v-if="scope.row.is_del === 1"
                class="mwow-tag del-filled large"
                >已删除</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="照片" width="90" prop="avatar">
          <template slot-scope="scope">
            <span v-if="scope.row.avatar_url === '-'">-</span>
            <div v-else>
              <el-popover placement="top" trigger="hover">
                <img height="240" :src="scope.row.source_avatar_url" />
                <a
                  :href="scope.row.source_avatar_url"
                  slot="reference"
                  target="_blank"
                  style="
                    display: inline-block;
                    border-radius: 50%;
                    overflow: hidden;
                    border: 1px solid #e7e8ea;
                    width: 30px;
                    height: 30px;
                  "
                >
                  <el-image
                    style="width: 30px; height: 30px"
                    fit="cover"
                    :src="scope.row.avatar_url"
                  />
                </a>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="180" prop="mobile">
          <template slot-scope="scope">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p style="text-align: center">
                {{ `${scope.row.wechat_status === 0 ? "未" : "已"}绑定微信` }}
              </p>
              <i
                class="iconfont icon-wechat"
                slot="reference"
                :style="`margin-left:6px;font-size:15px;color:${
                  scope.row.wechat_status === 0 ? '#CCCCCC' : '#01D20B'
                }`"
              ></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="sexname" width="100">
        </el-table-column>
        <el-table-column label="年龄" width="100">
          <template slot-scope="scope">
            <div>
              {{ scope.row.age }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所在班级">
          <template slot-scope="scope">
            <div v-if="scope.row.class_list.length > 0">
              <span v-for="(item, index) in scope.row.class_list" :key="index"
                >{{
                  index != scope.row.class_list.length - 1
                    ? item.name + ","
                    : item.name
                }}
              </span>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="班级教师">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.class_teacher_list
                  .map((item) => {
                    return item.name;
                  })
                  .join(",")
              }}
            </div>
            <div v-if="scope.row.class_teacher_list.length === 0">-</div>
          </template>
        </el-table-column>
        <el-table-column label="教务老师" prop="teacher_name">
        </el-table-column>
        <el-table-column
          label="课程顾问"
          prop="follow_staff_name"
          align="center"
        >
        </el-table-column>
        <el-table-column label="用户意向" prop="intent" align="center">
          <template slot-scope="scope">
            {{ followLatentObj[scope.row.intent] || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="首次入学时间"
          prop="transform_time"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            <div class="selfheader">
              <div>首次入学时间</div>
              <el-popover
                placement="top"
                popper-class="followuppopover"
                trigger="hover"
                width="133"
              >
                <p class="tipck">首次缴费变为在读学员的时间</p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="sortBox">
              {{ scope.row.transform_time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="最近入学时间"
          prop="latest_transform_time"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div class="sortBox">
              {{ scope.row.latest_transform_time }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
    <el-drawer
      title="创建新学员"
      :visible.sync="drawer"
      size="null"
      destroy-on-close
    >
      <div class="drawer_box">
        <el-form
          size="mini"
          ref="form"
          label-width="80px"
          class="drawer_form"
          :model="dialogForm"
          :rules="rules"
        >
          <div class="drawer_Head" style="margin-top: 20px">基本信息</div>
          <el-form-item label="用户照片:" class="drawerLenan_name">
            <avatar-cliper
              @change="handleAvatarChange"
              :originUrl="dialogForm.avatar_url"
              :originName="dialogForm.avatar"
            >
              <template v-slot="scope">
                <div
                  v-show="!scope.url"
                  style="width: 44px; height: 44px"
                ></div>
                <img
                  v-show="scope.url"
                  width="44"
                  height="44"
                  :src="scope.url"
                />
              </template>
            </avatar-cliper>
          </el-form-item>
          <el-form-item label="学员姓名:" prop="name">
            <el-input
              class="drawer_input"
              v-model="dialogForm.name"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="mobile">
            <div class="phone-style">
              <div class="phone-style-left">
                <el-select
                  slot="prepend"
                  placeholder="请选择"
                  v-model.number="dialogForm.mobile_relation"
                  class="drawer_selectchoose"
                >
                  <el-option
                    v-for="item in mobileRelationList"
                    :key="item.value"
                    :label="item.value"
                    :value="Number(item.key)"
                  ></el-option>
                </el-select>
              </div>
              <div class="phone-style-right">
                <select-region-phone-number
                  @change="areaCode"
                  :areaCode="mySreaCodePhone.code"
                >
                  <div class="mwow-green curp">
                    <span
                      >{{ "+" + mySreaCodePhone.code }}
                      <i class="el-icon-arrow-down"></i
                    ></span>
                  </div>
                </select-region-phone-number>
              </div>
            </div>
            <el-input
              class="drawer_input"
              v-model="dialogForm.mobile"
              type="tel"
              placeholder="请输入手机号码"
              :maxlength="maxNum"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="性别:">
            <el-select
              v-model.number="dialogForm.sex"
              placeholder="请选择"
              class="drawer_onlychoose"
            >
              <el-option
                v-for="item in sexList"
                :key="item.value"
                :label="item.value"
                :value="Number(item.key)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期:" class="drawer_chooseDate">
            <el-date-picker
              class="inputdate"
              type="date"
              placeholder="请选择"
              @change="dateChoose"
              value-format="timestamp"
              v-model="dialogForm.birthday"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <div class="inputyear" v-if="dialogForm.age !== 0">
              {{ dialogForm.age }} 岁
            </div>
            <div class="inputyear" v-else>{{ ageMonth }} 个月</div>
          </el-form-item>
          <div class="drawer_Head">其他信息</div>
          <el-form-item label="教务老师:">
            <div style="display: flex; align-items: center">
              <el-select
                v-model.number="dialogForm.teacher_id"
                filterable
                clearable
                placeholder="请选择"
                @clear="getSelectrList('teacher')"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'teacher');
                  }
                "
              >
                <el-option
                  v-for="item in eduName"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="Number(item.staff_id)"
                >
                </el-option>
              </el-select>
              <el-popover
                placement="top"
                trigger="hover"
                popper-class="followuppopover"
              >
                <p>用于接收学员请假等消息推送</p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item label="课程顾问:">
            <el-select
              v-model.number="dialogForm.follow_staff_id"
              filterable
              clearable
              placeholder="请选择"
              @clear="getSelectrList('staff')"
              :filter-method="
                (queryString) => {
                  globalSearch(queryString, 'staff');
                }
              "
            >
              <el-option
                v-for="item in staffName"
                :key="item.staff_id"
                :label="item.name"
                :value="Number(item.staff_id)"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="监护人:" prop="guardian_mobile">
            <div class="phone-style">
              <div class="phone-style-left">
                <el-select
                  slot="prepend"
                  placeholder="请选择"
                  v-model.number="dialogForm.guardian_relation"
                  class="drawer_selectchoose"
                >
                  <el-option
                    v-for="item in guardianList"
                    :key="item.value"
                    :label="item.value"
                    :value="Number(item.key)"
                  ></el-option>
                </el-select>
              </div>
              <div class="phone-style-right">
                <select-region-phone-number
                  @change="guardianAreaCode"
                  :areaCode="guardianSreaCodePhone.code"
                >
                  <div class="mwow-green curp">
                    <span
                      >{{ "+" + guardianSreaCodePhone.code }}
                      <i class="el-icon-arrow-down"></i
                    ></span>
                  </div>
                </select-region-phone-number>
              </div>
            </div>
            <el-input
              class="drawer_input guardian-number"
              placeholder="请输入手机号码"
              v-model="dialogForm.guardian_mobile"
              type="number"
              :maxlength="guardianMaxNum"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="出现方式:" prop="appear_id">
            <div style="display: flex; align-items: center">
              <el-select
                placeholder="请选择"
                v-model.number="dialogForm.appear_id"
                class="drawer_onlychoose appears"
                @change="handleChangeAppear"
              >
                <el-option
                  v-for="item in studentAppearLabelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-popover
                placement="top"
                trigger="hover"
                popper-class="followuppopover"
              >
                <p>
                  出现方式主要统计学员来自哪种类型，<br />
                  且目前共5大类分别是；<br />
                  Walk_In：主动到访门店的客户；<br />
                  Call_In：主动打电话资讯的客户；<br />
                  Net_In：通过线上方式资讯的客户；<br />
                  Call_Out：被动获得的客户；<br />
                  转介绍：转介绍来的客户；<br />
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item label="来源渠道:" prop="source_type">
            <el-select
              placeholder="请选择"
              v-model.number="dialogForm.source_type"
              class="drawer_onlychoose"
              @visible-change="handleVisibleChange"
            >
              <el-option
                v-for="item in sourceTypeList"
                :key="item.key"
                :label="item.value"
                :value="Number(item.key)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="家庭地址:">
            <el-input
              class="drawer_input"
              v-model="dialogForm.home_address"
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="就读学校:">
            <el-input
              class="drawer_input"
              v-model="dialogForm.school"
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="意向科目：">
            <el-select
              class="drawer_input"
              v-model="dialogForm.subject_ids"
              multiple
              filterable
              remote
              default-first-option
              :remote-method="
                (queryString) => {
                  globalSearch(queryString, 'subject');
                }
              "
              placeholder="请选择科目"
            >
              <el-option
                v-for="item in subjectsList"
                :key="item.subject_id"
                :label="item.subject_title"
                :value="item.subject_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              type="textarea"
              class="drawer_input"
              :rows="3"
              v-model="dialogForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
          <div class="drawer_bottomBtn">
            <div class="mwow-button-filled mini reloadbtn" @click="closeDrawer">
              取消
            </div>
            <div
              class="mwow-button-filled mini success reloadbtn"
              @click="postData('form')"
            >
              保存
            </div>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-dialog title="其他选择" :visible.sync="orderChooseBtn" width="30%">
      <div class="orderChoose">
        <div class="orderChooseSm" @click="clickChooseBox('details')">
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/stydydent01.png"
            alt=""
          />
          <div>预览详情</div>
        </div>
        <div class="orderChooseSm" @click="clickChooseBox('buy')">
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/stydydent02.png"
            alt=""
          />
          <div>购买课程</div>
        </div>
        <div class="orderChooseSm" @click="clickChooseBox('add')">
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/stydydent03.png"
            alt=""
          />
          <div>继续添加</div>
        </div>
        <div class="orderChooseSm" @click="clickChooseBox('back')">
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/stydydent04.png"
            alt=""
          />
          <div>返回首页</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
//头像鼠标放入变化，头像oss
import {
  studentList,
  addStudentHeader,
  addMobileRelation,
  addStudentGuardian,
  sourceTypeKVListApi,
  addsex,
  addStudent,
  studentListData,
  exportStudent,
} from "@/api/studentManage";
import {
  staffList,
  geteacherList,
  getSelectClassList,
  getSelectCourseList,
  getSeleSubjectsList,
} from "@/api/globalSearch";
import { getFollowLatentApi } from "@/api/studentFollow";
import { exportLoop } from "@/utils/export";
import { dateFormat, getAge } from "@/utils/timeFormat";
import avatarCliper from "@/components/avatarCliper.vue";
import { phonePass, guardianPhonePass } from "@/utils/rules";
import { PageModule } from "@/store/module/page";
import teacherEdit from "./teacherEdit.vue";
import followStaffEdit from "./followStaffEdit.vue";
import selectRegionPhoneNumber from "@/components/selectRegionPhoneNumber.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { getStudentAppearListApi } from "@/api/storeManagement";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "studying",
  components: {
    teacherEdit,
    followStaffEdit,
    selectRegionPhoneNumber,
    avatarCliper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  data() {
    return {
      showFormSearch: false,
      guardianMaxNum: 11,
      maxNum: 11,
      followLatentObj: {},
      mySreaCodePhone: {
        // 自己的手机区号
        checked: true,
        code: "86",
        code_id: 1,
        en_name: "China",
        name: "中国大陆",
      },
      guardianSreaCodePhone: {
        // 监护人手机区号
        checked: true,
        code: "86",
        code_id: 1,
        en_name: "China",
        name: "中国大陆",
      },
      searchInfo: {
        sort_type: "",
        sort_field: "",
        degree_of_interest: [],
        class_teacher_id: "",
        class_teacher_list: [],
        teacher_id: "",
        teacher_list: [],
        follow_staff_id: "",
        follow_staff_list: [],
        enter_date: "",
        latest_transform_time: "",
      }, //搜索数据
      drawer: false, //添加学员
      tableData: [], //列表数据
      dialogForm: {
        avatar: "",
        avatar_url: "",
        age: 0,
      }, //添加数据
      mobileRelationList: [], //手机关系人数据
      guardianList: [], //弹出监护人数据
      sourceTypeList: [], //弹出来源列表数据
      sexList: [], //弹出性别选择
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      page: 1,
      staffName: "", //员工搜索名字
      eduName: "", // 教务老师
      teacherName: "", //教师搜索名字
      className: "", //班级搜索类型
      courseName: "",
      dialogteacherName: "", //新增学员教师名字
      dialogstaffName: "", //新增学员员工名字
      ageMonth: 0,
      rules: {
        name: [{ required: true, message: "必填项不能为空", trigger: "blur" }],
        mobile: [{ required: true, validator: phonePass, trigger: "blur" }],
        appear_id: [
          { required: true, message: "请选择学员出现方式", trigger: "change" },
        ],
        source_type: [
          { required: true, message: "请选择学员来源渠道", trigger: "change" },
        ],
        // guardian_mobile:[{ required: true, validator: phonePass, trigger: "blur" }],
      },
      dialogVisible: false,
      student_id: 0,
      orderChooseBtn: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 3600 * 1000;
        },
      },
      imageUrlArry: [],
      subjectsList: [],
      loading: false,
      multipleSelection: [],
      // 未来时间应不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
      studentAppearLabelList: [],
    };
  },
  created() {
    const _t = this;
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = _t.$route.params;
      if (params.tab === "studying") {
        if (params.start_time && params.end_time) {
          _t.searchInfo.date = [params.start_time, params.end_time];
        }
      }
    } else {
      // 获取vuex里面的page和page_size
      const pageData = PageModule.pageInfo.studying;
      if (pageData.page) {
        _t.page = pageData.page;
      }
      if (pageData.page_size) {
        _t.pageSize = pageData.page_size;
      }
      if (pageData.search_info) {
        _t.searchInfo = pageData.search_info;
      }
      const cache = PageModule.pageInfo.studyDetails;
      if (cache.tab) {
        PageModule.SET_PAGE_INFO({
          name: "studyDetails",
          key: "tab",
          value: "",
        });
      }
    }
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
      status: 1,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
    this.getList(
      {
        page: _t.page,
        page_size: _t.pageSize,
      },
      () => {
        _t.getHead();
        _t.globalSearch("", "staff");
        _t.globalSearch("", "class");
        _t.globalSearch("", "teacher");
        _t.globalSearch("", "subject");
        _t.getFormList(addsex, "sexList");
      }
    );
    getFollowLatentApi().then((res) => {
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
  },
  methods: {
    // 去到学员详情
    goStudentDetail(sid) {
      this.cachePageInfo();
      this.$router.push({
        name: "studyDetails",
        query: {
          id: sid,
        },
      });
    },
    resetSearch() {
      this.searchInfo = {
        sort_type: this.searchInfo.sort_type,
        sort_field: this.searchInfo.sort_field,
        degree_of_interest: [],
        class_teacher_id: "",
        teacher_id: "",
        follow_staff_id: "",
        class_teacher_list: [],
        teacher_list: [],
        follow_staff_list: [],
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList(
        {
          page: this.page,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    // 导出开始
    clickexport(data) {
      const _t = this;
      if (_t.searchInfo.sex) {
        data.sex = _t.searchInfo.sex;
      }
      if (_t.searchInfo.key_word) {
        data.key_word = _t.searchInfo.key_word;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.teacher_id) {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.follow_staff_id !== "") {
        data.follow_staff_id = Number(_t.searchInfo.follow_staff_id);
      }
      if (_t.searchInfo.class_teacher_id) {
        data.class_teacher_id = _t.searchInfo.class_teacher_id;
      }
      if (_t.searchInfo.degree_of_interest.length > 0) {
        data.intent_arr = _t.searchInfo.degree_of_interest;
      }
      exportStudent(data).then((res) => {
        if (res.error_code == 0) {
          exportLoop(res.data.task_id);
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    lookDetails(e) {
      const _t = this;
      _t.$router.push({ name: "studyDetails", query: { id: e.id } });
    },
    // 导出结束
    clickChooseBox(type) {
      const _t = this;
      if (type == "details") {
        _t.lookDetails({ id: _t.student_id });
      } else if (type == "buy") {
        _t.$router.push({
          name: "buyCourseConfirm",
          query: { id: _t.student_id },
        });
      } else if (type == "add") {
        _t.addStudent();
      } else {
        _t.$router.push({ name: "dashboard" });
      }
      _t.orderChooseBtn = false;
    },
    checkNumber(theObj) {
      const regPos = /^\d+(\.\d+)?$/; //非负浮点数
      const regNeg =
        /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(theObj) || regNeg.test(theObj)) {
        return true;
      } else {
        return false;
      }
    },
    handleAvatarChange(key) {
      // 用户照片更新
      this.dialogForm.avatar = key;
    },
    addStudent() {
      this.cachePageInfo();
      let _t = this;
      // _t.getFormList(sourceTypeKVListApi, "sourceTypeList");
      _t.getFormList(addStudentGuardian, "guardianList");
      _t.getFormList(addMobileRelation, "mobileRelationList");
      // _t.getHead();
      const randomAvatarIndex = Math.floor(
        Math.random() * _t.imageUrlArry.length
      );
      _t.dialogForm = {
        avatar: _t.imageUrlArry[randomAvatarIndex].avatar,
        avatar_url: _t.imageUrlArry[randomAvatarIndex].avatar_url,
        mobile_relation: 1,
        guardian_relation: 2,
        age: 0,
        source_type: "",
      };
      this.mySreaCodePhone.code = "86";
      this.guardianMaxNum = 11;
      this.maxNum = 11;
      this.drawer = true;
    },
    closeDrawer() {
      this.drawer = false;
    },
    // 通用搜索框
    getSelectrList(e) {
      const _t = this;
      _t.globalSearch("", e);
    },

    getglobalsearchdata(data, type) {
      if (type == "staff") {
        data.job_ids = [3];
        data.status = 1;
        return staffList(data);
      } else if (type === "class_teacher") {
        return geteacherList(data);
      } else if (type == "teacher") {
        data.job_ids = [2];
        return staffList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      } else if (type == "subject") {
        data.status = 1;
        return getSeleSubjectsList(data);
      }
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else if (type == "staff") {
          data.key_word = queryString;
        } else if (type == "subject") {
          data.title = queryString;
        } else if (type == "teacher" || type == "class_teacher") {
          data.key_word = queryString;
        }
      }
      if (type == "subject") {
        data.page_size = 500;
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;

      if (type == "staff") {
        _t.staffName = list;
      } else if (type == "teacher") {
        _t.eduName = list;
      } else if (type == "class_teacher") {
        _t.teacherName = list;
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      } else if (type == "subject") {
        _t.subjectsList = list != null ? list : [];
      }
    },
    // 通用搜索框结束
    getList(data, cb) {
      const _t = this;
      if (_t.searchInfo.sex) {
        data.sex = _t.searchInfo.sex;
      }
      if (_t.searchInfo.key_word) {
        data.key_word = _t.searchInfo.key_word;
      }
      if (_t.searchInfo.class_id !== "") {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.teacher_id !== "") {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.follow_staff_id !== "") {
        data.follow_staff_id = Number(_t.searchInfo.follow_staff_id);
      }
      if (_t.searchInfo.age_start) {
        data.age_start = _t.searchInfo.age_start;
      }
      if (_t.searchInfo.age_end) {
        data.age_end = _t.searchInfo.age_end;
      }
      // if (_t.searchInfo.date_end) {
      //   data.end_time = String(_t.searchInfo.date_end);
      // }
      // if (_t.searchInfo.date_start) {
      //   data.start_time = String(_t.searchInfo.date_start);
      // }
      if (_t.searchInfo.enter_date && _t.searchInfo.enter_date.length === 2) {
        data.start_time = dateFormat("YYYY-mm-dd", _t.searchInfo.enter_date[0]);
        data.end_time = dateFormat("YYYY-mm-dd", _t.searchInfo.enter_date[1]);
      }
      if (
        _t.searchInfo.latest_transform_time &&
        _t.searchInfo.latest_transform_time.length === 2
      ) {
        data.latest_transform_start_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.latest_transform_time[0]
        );
        data.latest_transform_end_time = dateFormat(
          "YYYY-mm-dd",
          _t.searchInfo.latest_transform_time[1]
        );
        data.sort_field = "latest_transform_time";
      }
      if (_t.searchInfo.class_teacher_id) {
        data.class_teacher_id = _t.searchInfo.class_teacher_id;
      }
      if (_t.searchInfo.sort_type) {
        data.sort_type = _t.searchInfo.sort_type;
      }
      if (_t.searchInfo.sort_field) {
        data.sort_field = _t.searchInfo.sort_field;
      }
      if (_t.searchInfo.degree_of_interest.length > 0) {
        data.intent_arr = _t.searchInfo.degree_of_interest;
      }
      if (_t.searchInfo.age_stage > 0) {
        data.age_stage = _t.searchInfo.age_stage;
      }
      if (
        _t.searchInfo.age_start &&
        parseInt(_t.searchInfo.age_start) !==
          parseFloat(_t.searchInfo.age_start)
      ) {
        _t.$message({
          message: "开始年龄不能为小数",
          type: "error",
        });
        return;
      }
      if (
        _t.searchInfo.age_end &&
        parseInt(_t.searchInfo.age_end) !== parseFloat(_t.searchInfo.age_end)
      ) {
        _t.$message({
          message: "结束年龄不能为小数",
          type: "error",
        });
        return;
      }
      studentList(data).then((res) => {
        if (res.error_code == 0) {
          const today = new Date().getTime();
          if (res.data.list != null) {
            res.data.list.map((item) => {
              item.sexname = item.sex == 0 ? "-" : item.sex == 1 ? "男" : "女";
              item.transform_time = dateFormat(
                "YYYY-mm-dd",
                new Date(Number(item.transform_time + "000"))
              );
              item.latest_transform_time = dateFormat(
                "YYYY-mm-dd",
                new Date(Number(item.latest_transform_time + "000"))
              );
              Object.keys(item).filter(function (a) {
                if (item[a] === "") {
                  item[a] = "-";
                }
              });
              if (item.age === 0) {
                if (item.birthday !== 0) {
                  const severalMonths = today - item.birthday * 1000;
                  item.age = new Date(severalMonths).getMonth() + "个月";
                } else {
                  item.age = "-";
                }
              } else {
                item.age = item.age + "岁";
              }
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (cb) {
            cb();
          }
        }
      });
    },
    //获取头像
    getHead() {
      addStudentHeader().then((res) => {
        const _t = this;
        if (res.error_code == 0) {
          _t.imageUrlArry = res.data.list;
        }
      });
    },
    //获取表单列表
    getFormList(cb, type) {
      const _t = this;
      cb().then((res) => {
        if (res.error_code == 0) {
          _t[type] = res.data.list;
        }
      });
    },
    postData(formName) {
      const _t = this;
      if (!_t.dialogForm.name || _t.dialogForm.name == "") {
        _t.$message({
          type: "error",
          message: "必填项不能为空!",
        });
        return;
      }
      if (!_t.dialogForm.mobile || _t.dialogForm.mobile == "") {
        _t.$message({
          type: "error",
          message: "请输入正确的手机号!",
        });
        return;
      }
      // if (!_t.dialogForm.guardian_mobile || _t.dialogForm.guardian_mobile == "") {
      //   _t.$message({
      //     type: "error",
      //     message: "请输入正确的监护人手机号!",
      //   });
      //   return;
      // }
      _t.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loading) {
            return false;
          }
          const params = { ..._t.dialogForm, status: 2 };
          delete params.avatar_url;
          if (params.birthday) {
            params.birthday = params.birthday / 1000;
          }
          if (!params.teacher_id) {
            delete params.teacher_id;
          }
          if (!params.follow_staff_id) {
            delete params.follow_staff_id;
          }
          this.loading = true;
          if (_t.mySreaCodePhone.code) {
            params.area_code = _t.mySreaCodePhone.code;
          }
          if (_t.guardianSreaCodePhone.code) {
            params.guardian_area_code = _t.guardianSreaCodePhone.code;
          }
          params.ignore_exist_mobile = false;
          addStudent(params)
            .then((res) => {
              setTimeout(() => {
                this.loading = false;
              }, 1000);
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: "添加成功!",
                });
                _t.getList(
                  {
                    page: 1,
                    page_size: _t.pageSize,
                  },
                  () => {}
                );
                _t.drawer = false;
                _t.orderChooseBtn = true;
                if (res.data.student_id) {
                  _t.student_id = res.data.student_id;
                }
              } else if (res.error_code == 21009004) {
                _t.$confirm(
                  `姓名与历史学员冲突，确定提交后将修改历史学员姓名，并随机生成后缀，例如：${_t.dialogForm.name}_asd0asdf`,
                  `学员信息重复 - ${_t.dialogForm.name}`,
                  {
                    confirmButtonText: "确定",
                    confirmButtonClass: "mwow-button-filled success mini",
                    cancelButtonText: "取消",
                    cancelButtonClass: "mwow-button-filled mini",
                    iconClass: "mwow-icon-error",
                  }
                )
                  .then(() => {
                    _t.dialogForm.force = 1;
                    _t.postData(formName);
                  })
                  .catch(() => {});
              } else if (res.error_code == 21009011) {
                _t.$confirm(
                  "录入学员的手机号已存在，确认是否继续录入",
                  "新增在读学员-手机号已存在",
                  {
                    confirmButtonText: "继续录入",
                    confirmButtonClass: "mwow-button-filled success mini",
                    cancelButtonText: "暂不录入",
                    cancelButtonClass: "mwow-button-filled mini",
                    iconClass: "mwow-icon-error",
                  }
                )
                  .then(() => {
                    params.ignore_exist_mobile = true;
                    addStudent(params).then((res) => {
                      if (res.error_code === 0) {
                        setTimeout(() => {
                          _t.loading = false;
                        }, 1000);
                        _t.$message({
                          type: "success",
                          message: "添加成功",
                        });
                        _t.getList(
                          {
                            page: 1,
                            page_size: _t.pageSize,
                          },
                          () => {}
                        );
                        _t.drawer = false;
                        _t.orderChooseBtn = true;
                        if (res.data.student_id) {
                          _t.student_id = res.data.student_id;
                        }
                      }
                    });
                  })
                  .catch(() => {
                    setTimeout(() => {
                      _t.loading = false;
                    }, 100);
                  });
              } else {
                _t.$message({
                  type: "error",
                  message: "添加失败!" + res.message,
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    //日期选择
    dateChoose(e) {
      const _t = this;
      if (e < -2147483648 * 1000) {
        _t.$message({
          type: "error",
          message: "出生日期超出可选范围!",
        });
        _t.dialogForm.birthday = 0;
        _t.dialogForm.age = 0;
        _t.ageMonth = 0;
        return;
      }
      if (e != null) {
        const age = getAge(e);
        _t.dialogForm.age = age[0];
        _t.ageMonth = age[1];
      } else {
        _t.dialogForm.age = 0;
        _t.ageMonth = 0;
      }
    },
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "studying",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "studying",
        key: "page_size",
        value: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "studying",
        key: "search_info",
        value: this.searchInfo,
      });
    },
    handlePagerChange(e) {
      this.cachePageInfo();
      this.getList(
        {
          page: e,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.cachePageInfo();
      this.getList(
        {
          page: 1,
          page_size: e,
        },
        () => {}
      );
    },
    handleSearch() {
      const _t = this;
      this.getList(
        {
          page: 1,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },

    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },

    handleRefresh() {
      const _t = this;
      this.getList(
        {
          page: 1,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },
    areaCode(data) {
      PageModule.SET_PAGE_INFO({
        name: "areaCodePhoneNumber",
        key: "area_code",
        value: data[0].code,
      });
      if (data) {
        this.mySreaCodePhone = data[0];
        if (
          data[0].code !== "86" &&
          data[0].code !== "852" &&
          data[0].code !== "853" &&
          data[0].code !== "886"
        ) {
          this.maxNum = 16;
          return;
        } else if (data[0].code === "852" || data[0].code === "853") {
          this.maxNum = 8;
          return;
        } else if (data[0].code === "886") {
          this.maxNum = 10;
          return;
        } else {
          this.maxNum = 11;
          return;
        }
      }
    },
    guardianAreaCode(data) {
      PageModule.SET_PAGE_INFO({
        name: "guardianAreaCodePhoneNumber",
        key: "area_code",
        value: data[0].code,
      });
      if (data) {
        this.guardianSreaCodePhone = data[0];
        if (
          data[0].code !== "86" &&
          data[0].code !== "852" &&
          data[0].code !== "853" &&
          data[0].code !== "886"
        ) {
          this.guardianMaxNum = 16;
          return;
        } else if (data[0].code === "852" || data[0].code === "853") {
          this.guardianMaxNum = 8;
          return;
        } else if (data[0].code === "886") {
          this.guardianMaxNum = 10;
          return;
        } else {
          this.guardianMaxNum = 11;
          return;
        }
      }
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList(
        {
          page: 1,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    // 优化出现方式
    handleChangeAppear() {
      sourceTypeKVListApi({ appear_id: this.dialogForm.appear_id }).then(
        (res) => {
          this.sourceTypeList = res.data.list;
        }
      );
      this.dialogForm.source_type = "";
    },
    handleVisibleChange(e) {
      if (e) {
        if (!this.dialogForm.appear_id) {
          this.sourceTypeList = [];
          return this.$message({
            message: "请选择出现方式",
            type: "warning",
          });
        }
      }
    },
    beforeDestroy() {
      PageModule.SET_PAGE_INFO({
        name: "areaCodePhoneNumber",
        key: "area_code",
        value: "",
      });
      PageModule.SET_PAGE_INFO({
        name: "guardianAreaCodePhoneNumber",
        key: "area_code",
        value: "",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
}
.searchBox {
  margin-top: 12px;
  .inputBox {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 30px;
    height: 30px !important;
    position: relative;
    .el-input {
      width: 165px;
    }
    /deep/.el-input__inner {
      border: none !important;
    }
    span {
      margin: 0 10px 0 0;
    }
  }
}
.orderChoose {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  .orderChooseSm {
    width: 40%;
    cursor: pointer;
    div {
      color: #5c5d5e;
      font-size: 14px;
      margin: 12px 0;
      text-align: center;
    }
    img {
      width: 100%;
      min-width: 140px;
      min-height: 94px;
    }
  }
}
.el-form .el-form-item__label {
  text-align: left !important;
}
//添加学员盒子
.drawer_box {
  padding: 0 5%;
}
.drawer_Head {
  font-size: 14px;
  color: #5c5d5e;
  margin-bottom: 14px;
}
.drawer_bottomBtn {
  display: flex;
  justify-content: flex-end;
  max-width: 380px;
  .reloadbtn {
    line-height: 22px !important;
    padding: 0 !important;
    width: 44px !important;
    text-align: center;
  }
  .reloadbtn:nth-of-type(1) {
    margin-right: 10px;
  }
}
/deep/ .drawer_form {
  .drawer_chooseDate {
    margin-right: 0 !important;
    background: #fff;
    .el-form-item__content {
      display: flex;
    }
    .inputdate {
      width: 185px;
      .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
    .inputyear {
      width: 75px;
      height: 28px;
      display: inline-block;
      text-align: center;
      border-radius: 0 4px 4px 0px;
      border: 1px solid #dcdfe6;
      vertical-align: middle;
      margin-left: -1px;
      text-align: center;
    }
  }
  .drawer_input {
    width: 260px;
    .el-input-group__prepend {
      background: #fff;
    }
  }
  .drawer_onlychoose {
    .el-input {
      width: 260px;
    }
  }
  .drawer_selectchoose {
    .el-input {
      width: 80px;
    }
    .el-input__inner {
      padding-left: 6px;
    }
  }
}

/deep/ .drawerLenan_name {
  .el-form-item__label {
    line-height: 44px !important;
  }
}
/deep/ .avatar-uploader {
  .el-upload {
    border: 1px dashed #e7e8ea;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
}
.avatar {
  width: 44px;
  height: 44px;
  display: block;
}
.studentName {
  cursor: pointer;
}
.muti-buttons {
  .btn {
    padding-left: 10px;
    line-height: 28px;
    font-size: 12px;
    color: #5c5d5e;
    cursor: pointer;
    &:hover {
      background: #f5f7fa;
      color: #07d1aa;
    }
  }
  .dialog-wrap {
    display: block;
  }
}
/deep/.guardian-number {
  .el-input__inner {
    line-height: normal;
  }
}
/deep/ .phone-style {
  width: 260px;
  display: flex;
  margin-bottom: 12px;
  .phone-style-left {
    width: 50%;
    .el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 4px 0 0 4px !important;
        text-align: center;
      }
      .el-input__icon {
        margin-right: 34px;
      }
    }
  }
  .phone-style-right {
    cursor: pointer;
    width: 50%;
    text-align: center;
    border: 1px solid #e7e8ea;
    border-left: none;
    border-radius: 0 4px 4px 0;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .cell {
        display: flex !important;
        align-items: center;
      }
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
/deep/ .el-form {
  .el-form-item {
    width: 100%;
    display: flex;
    .el-form-item__label {
      min-width: 86px;
      text-align: right;
    }
    .el-form-item__content {
      margin-right: 58px;
      margin-left: 0 !important;
      width: 100%;
      flex: 1;
      .inputBox {
        display: flex;
        position: relative;
        &:hover {
          .clear-icon {
            display: block;
          }
        }
        .clear-icon {
          position: absolute;
          top: 8px;
          right: 0;
          font-size: 14px;
          color: #d8d8d8;
          cursor: pointer;
          display: none;
        }
        .el-input {
          width: auto;
          text-align: center;
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}
.time-line-switch {
  position: absolute;
  top: 41px;
  right: 0px;
  .p4 {
    padding: 8px;
    font-size: 12px;
    cursor: pointer;
    color: #5c5d5e;
    span {
      font-size: 14px;
      color: #c0c4cc;
      margin-left: 4px;
    }
  }
}
.resetting {
  top: 90px !important;
  right: 0px !important;
}
.appears {
  /deep/ .el-input {
    width: 220px !important;
  }
}
.selfheader {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
</style>
